import LegalLayout from "@/components/LegalLayout";

export default function License() {
    return (
        <LegalLayout
            testId="license-page"
            title="License Policy"
            effectiveDate="02-02-2024"
        >
            <p>
                Thank you for choosing FilesCAD! This License Policy outlines the terms and conditions under which FilesCAD grants you a license to use our digital files and designs. By purchasing and downloading digital files from FilesCAD, you agree to abide by the terms set forth in this License Policy.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">1. Licensing Agreement</h3>
            <p>
                FilesCAD grants you a non-exclusive, non-transferable, and revocable license to use the purchased digital files for personal or commercial purposes, subject to the terms and conditions outlined herein.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">2. Permitted Uses</h3>
            <ul className="list-decimal pl-6 space-y-1">
                <li>Manufacturing physical objects based on the digital designs.</li>
                <li>Personal or commercial projects, including but not limited to prototypes, products, and artistic creations.</li>
                <li>Resize and modify these files using any CAD software.</li>
            </ul>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">3. Prohibited Uses</h3>
            <p>You may not:</p>
            <ul className="list-decimal pl-6 space-y-1">
                <li>Resell, sublicense, or distribute the digital files in their original or modified form.</li>
                <li>Use the digital files in a way that infringes upon the intellectual property rights of FilesCAD or any third party.</li>
                <li>Create derivative works from the digital files for the purpose of resale or distribution.</li>
            </ul>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">4. Ownership and Intellectual Property</h3>
            <p>
                All intellectual property rights, including copyrights, in and to the digital files remain the exclusive property of FilesCAD or its licensors. This license does not grant you any rights to use FilesCAD&rsquo;s name, logo, or branding.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">5. File Modifications</h3>
            <p>
                You may modify the digital files to suit your specific needs, but you may not distribute or sell these modified files.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">6. Termination</h3>
            <p>
                FilesCAD reserves the right to terminate this license at any time if you breach any of the terms and conditions.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Contact Us</h3>
            <p>
                If you have any questions or concerns about our License Policy, please contact us at:{" "}
                <a
                    href="mailto:support@filescad.com"
                    data-testid="license-contact-email"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
            </p>

            <p className="mt-8 italic text-slate-500">
                By purchasing and downloading digital files from FilesCAD, you agree to this License Policy. FilesCAD reserves the right to update this policy from time to time, and any changes will be communicated to users.
            </p>
        </LegalLayout>
    );
}
